<template>
  <div id="app" >
    <router-view style="width: 100%;heihgt: 100%;"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0px 1px rgba(0, 0, 0, 0.2);
  background: #777;
}

::-webkit-scrollbar-track {
  border-radius: 20px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
  border-radius: 1px;
  background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue